import {
    ACCESSORIES_DC_DETAILS_USERFORM_RESET,
    ACCESSORIES_DC_DETAILS_USERFORM_SELECTED_ROWS,
    CREATE_ACCESSORIES_DC_DETAILS_FAILURE,
    CREATE_ACCESSORIES_DC_DETAILS_REQUEST,
    CREATE_ACCESSORIES_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_ACCESSORIES_DC_DETAILS,
    DELETE_ACCESSORIES_DC_DETAILS_FAILURE,
    DELETE_ACCESSORIES_DC_DETAILS_REQUEST,
    DELETE_ACCESSORIES_DC_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE,
    FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST,
    FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_ACCESSORIES_DC_DETAILS_FAILURE,
    FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_FAILURE,
    FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_REQUEST,
    FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_ACCESSORIES_DC_DETAILS_REQUEST,
    FETCH_ACCESSORIES_DC_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE,
    FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST,
    FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST,
    FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS,
    UPDATE_ACCESSORIES_DC_DETAILS_FAILURE,
    UPDATE_ACCESSORIES_DC_DETAILS_REQUEST,
    UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS,
    UPDATE_ACCESSORIES_DC_FAILURE,
    UPDATE_ACCESSORIES_DC_REQUEST,
    UPDATE_ACCESSORIES_DC_SUCCESS
} from "./accessoriesDCDetails.actionsType";


export const ACCESSORIES_DC_DETAILS = 'accessoriesDCDetails';

let initialState = {
    loading: false,
    accessoriesDCDetailsById: [],
    accessoriesDCDetails: [],
    userform: {
        fldIsCora: false,
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldCostPerBag: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        previousFldId: []
    },
    selectedAccessoriesDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    previousList: [],
    selectedRows: [],
    selectedRow:{},
    updatedList: [],
    groupList: []
};

export let accessoriesDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_DC_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_ACCESSORIES_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST:
        case UPDATE_ACCESSORIES_DC_DETAILS_REQUEST:
        case DELETE_ACCESSORIES_DC_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST:
        case UPDATE_ACCESSORIES_DC_REQUEST:
        case FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDCDetails: updatePayload
            };
        case FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDCDetailsById: updatePayload
            };
        case UPDATE_ACCESSORIES_DC_SUCCESS: {
            return {
                ...state,
                loading: false,
                updatedList: updatePayload
            };
        }
        case CREATE_ACCESSORIES_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                previousList: []
            };
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDCDetails: updatePayload,
                userform: updatePayload
                /*userform: {
                    employee: updatePayload.fldFKEmployee,
                    designation: updatePayload.fldEmployeeDesgination,
                    roleInTeam: updatePayload.fldFKRolesInTeam
                }*/
            };
        case UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDCDetails: {},
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                }
            };
        case DELETE_ACCESSORIES_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                selectedAccessoriesDCDetails: {}
            };
        case FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload.ACD,
            };
        case ACCESSORIES_DC_DETAILS_USERFORM_SELECTED_ROWS:
            return {
                ...state,
                loading: false,
                selectedRows: payload
            };
        case FETCH_ACCESSORIES_DC_DETAILS_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE:
        case CREATE_ACCESSORIES_DC_DETAILS_FAILURE:
        case UPDATE_ACCESSORIES_DC_DETAILS_FAILURE:
        case DELETE_ACCESSORIES_DC_DETAILS_FAILURE:
        case FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE:
        case UPDATE_ACCESSORIES_DC_FAILURE:
        case FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE:
        case FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case ACCESSORIES_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                selectedAccessoriesDCDetails: {},
                previousList: [],
                updatedList: []
            };
        default:
            return state;
    }
};
